export const parseDateString = dateStr => {
  if (!dateStr || typeof dateStr !== 'string') {
    return null;
  }
  const parts = dateStr.split('/');
  const dateParts = 3;
  if (parts.length !== dateParts) {
    return null;
  }
  const [day, month, year] = parts.map(Number);
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return null;
  }
  const date = new Date(year, month - 1, day);
  return isNaN(date.getTime()) ? null : date;
};

export const formatDateToString = date => {
  if (!(date instanceof Date)) {
    return '';
  }
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const geDateOffset = offset => {
  const offsetDays = Number(offset) || 0;
  const dateOffset = new Date();
  dateOffset.setDate(dateOffset.getDate() + offsetDays);
  return dateOffset;
};

export const getOrdinal = n => {
  if (n === undefined) {
    return '';
  }

  const ordinalSuffixOffset = 20;
  const suffixModulo = 10;
  const ordinalModulo = 100;
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % ordinalModulo;
  return n + (suffixes[(v - ordinalSuffixOffset) % suffixModulo] || suffixes[v] || suffixes[0]);
};

export const calculateAgeAtDate = (dob, coverDate) => {
  if (!dob || !coverDate) {
    return null;
  }

  const birth = dob instanceof Date ? dob : new Date(dob);
  const cover = coverDate instanceof Date ? coverDate : parseDateString(coverDate);

  if (!birth || !cover) {
    return null;
  }

  let age = cover.getFullYear() - birth.getFullYear();
  const monthDiff = cover.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && cover.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};
